import React, { Fragment } from 'react';
import axios from 'axios';
import Qs from 'qs'
import { Link } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import Swal from 'sweetalert2'
import {
  Row,
  Col,
  CardBody,
  Card,
  CustomInput,
  FormGroup,
  Input,
  Badge,
  UncontrolledTooltip,
  TabContent,
  TabPane,
  Nav,
  NavItem,
  NavLink,
  Button
} from 'reactstrap';

import hero9 from '../assets/images/hero-bg/hero-9.jpg';

export default class RegisterPage extends React.Component {
  constructor(props) {
    super(props);
    //lang: this.props.match.params.lang,
    let show_image = true;
    if (props.show_image !== undefined) {
      show_image = props.show_image;
    }
    this.state = { code_info: "Click to get" };
  }

  handleRegistration()
  {
    let email=document.getElementById("registration_email").value;
    let name=document.getElementById("registration_name").value;
    let password=document.getElementById("registration_password").value;
    let code=document.getElementById("registration_code").value;

    if(email===""||name===""||password===""||code==="")
    {
      Swal.fire(
        'Incorrect Information',
        'Please try again!',
        'error');
      return;
    }
    let storage = window.localStorage;
    axios.post(storage.ch_action_url + "/action/registration", Qs.stringify({
      email: email,
      password: password,
      name:name,
      code:code
    })).then(res => {
      console.log(res);
      if (res.data.status === 0) {
        Swal.fire(
          'Error!',res.data.info,
          'error');
      }
      else {
        Swal.fire(
          'Good Job',
          'You have been registerred, please wait for permission from admin!',
          'success').then((result) => {
              window.location.href= window.location.origin + "/" + window.localStorage.ch_domain_name + "/home/all";
            });
      }

    }).catch(error => {
      console.log(error);
    });
  }

  handleGetValidationCode() {
    let storage = window.localStorage;
    let email=document.getElementById("registration_email").value;
    if(email==="")
    {
      Swal.fire(
        'Incorrect Information',
        'Please input correct email address!',
        'error');
      return;
    }
    this.setState({code_info:"sending code..."})
    axios.post(storage.ch_action_url + "/action/get_registration_code", Qs.stringify({
      email: email    })).then(res => {
      console.log(res);
      this.setState({code_info:"Click to get"})
      if (res.data.status=== 0) {
        //window.location.href = "#/";
        Swal.fire(
          'Error',
          res.data.info,
          'error');
      }
      else {
        Swal.fire(
          'Good Job',
          'The validation code has been sent to your email!',
          'success')
      }

    }).catch(error => {
      console.log(error);
    });
  }
  render() {

    return (
      <Fragment>
        <div className="app-wrapper min-vh-100 bg-white">
          <div className="app-main min-vh-100">
            <div className="app-content p-0">
              <div className="app-inner-content-layout--main">
                <div className="flex-grow-1 w-100 d-flex align-items-center">
                  <div className="bg-composed-wrapper--content">
                    <Row className="min-vh-100 no-gutters">
                      <Col lg="5" className="order-2 order-lg-1 d-flex">
                        <div className="hero-wrapper w-100 bg-composed-wrapper bg-plum-plate min-vh-lg-100">
                          <div className="flex-grow-1 w-100 d-flex align-items-center">
                            <div
                              className="bg-composed-wrapper--image"
                              style={{ backgroundImage: 'url(' + hero9 + ')' }}
                            />
                            <div className="bg-composed-wrapper--bg bg-premium-dark opacity-5" />
                            <div className="bg-composed-wrapper--content p-5">
                              <div className="d-flex align-items-center">
                                <Badge
                                  pill
                                  color="second"
                                  className="px-4 h-auto py-1">
                                  Register page
                              </Badge>
                                <span
                                  className="text-white-50 pl-3"
                                  id="DetailsTooltip1">
                                  <FontAwesomeIcon
                                    icon={['far', 'question-circle']}
                                  />
                                </span>
                                <UncontrolledTooltip
                                  target="DetailsTooltip1"
                                  placement="right"
                                  container="body">
                                  Create your own register or login pages using
                                  the included elements.
                              </UncontrolledTooltip>
                              </div>
                              <div className="text-white mt-3">
                                <h1 className="display-4 my-3 font-weight-bold">
                                  Why should you join Huaxia Chorus?
                              </h1>
                                <p className="font-size-md mb-0 text-white-50">
                                  A free hour, when our power of choice is
                                  untrammelled and when nothing prevents.
                              </p>
                                <div className="divider border-2 my-5 border-light opacity-2 rounded w-25" />
                                <div>
                                  <Button
                                    tag={Link}
                                    size="lg"
                                    color="warning"
                                    to="/">
                                    <span className="btn-wrapper--icon">
                                      <FontAwesomeIcon
                                        icon={['fas', 'arrow-left']}
                                      />
                                    </span>
                                    <span className="btn-wrapper--label">
                                      Back to Home
                                  </span>
                                  </Button>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </Col>
                      <Col
                        xl="7"
                        lg="8"
                        className="order-1 order-lg-2 d-flex align-items-center">
                        <div className="px-3 pb-3 pt-4">
                          <h3 className="display-4 mb-2 font-weight-bold">
                            Create account
                        </h3>
                          <p className="font-size-lg mb-5 text-black-50">
                            Fill in the fields below and you'll be good to
                            go.
                        </p>
                          <FormGroup>
                            <label>Email address</label>
                            <Input
                              id="registration_email"
                              placeholder="Enter your email address"
                              type="email"
                            />
                          </FormGroup>
                          <FormGroup>
                            <div className="d-flex justify-content-between mg-b-5">
                              <label>Password</label>
                            </div>
                            <Input
                               id="registration_password"
                              placeholder="Enter your password"
                              type="password"
                            />
                          </FormGroup>
                          <FormGroup>
                            <label>Name</label>
                            <Input
                              id="registration_name"
                              placeholder="Enter your name"
                              type="text"
                            />
                          </FormGroup>
                          <FormGroup>
                            <label>Validation Code</label><span onClick={()=>this.handleGetValidationCode()} className="ml-3 text-warning" style={{cursor:"pointer"}}>{this.state.code_info}</span>
                            <Input
                              id="registration_code"
                              placeholder="Enter your code"
                              type="text"
                            />
                          </FormGroup>
                          <div className="form-group mb-5">
                            By clicking the <strong>Create account</strong>{' '}
                          button below you agree to our terms of service
                          and privacy statement.
                          </div>

                          <Button
                            color="primary"
                            size="lg"
                            block={true}
                            onClick={()=>this.handleRegistration()}
                            className="mb-5">
                            Create Account
                        </Button>
                        </div>
                      </Col>
                    </Row>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </Fragment>
    );
  }
}